import { render } from "./demo-ai-tree-virtual1.vue?vue&type=template&id=7acfe508"
import script from "./demo-ai-tree-virtual1.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-ai-tree-virtual1.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/demo/demo-ai-tree-virtual1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7acfe508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7acfe508', __exports__)) {
    api.reload('7acfe508', __exports__)
  }
  
  module.hot.accept("./demo-ai-tree-virtual1.vue?vue&type=template&id=7acfe508", () => {
    api.rerender('7acfe508', render)
  })

}


export default __exports__